module.exports = __webpack_public_path__ + "img/16.20611be4.jpg";